import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useSearch } from '../../contexts/search';
import { ILeadServedOutcomeView } from '../../viewModels/leads/interfaces';
import { LeadServedSource } from '../../viewModels/queue';
import { CardView } from '../CardView';
import { CardableContact } from '../CardableContact';

interface IProps {
	lead?: ILeadServedOutcomeView;
	source: LeadServedSource;
}

export const LeadCard2: React.FC<IProps> = ({ lead, source }) => {
	const history = useHistory();
	const searchModal = useSearch();
	const renderContactInfo = () => {
		return <CardableContact contact={lead.contact} />;
	};

	const onClick = () => {
		history.push({
			pathname: '/queue',

			search: `?from=${source}&companyId=${lead.company.id}`,
		});
		searchModal.setShowSearch(false);
	};

	if (!lead) {
		return null;
	}

	return (
		<CardView
			followUp={lead.followUp}
			lastDeal={lead.lastDeal}
			nextMeeting={lead.nextMeeting}
			name={lead.company?.companyName}
			leadId={lead.company?.id}
			phone={lead.company?.phoneNumbers[0]?.metadata?.standard}
			website={lead.company?.webSite}
			onClick={onClick}
			contactInfo={renderContactInfo}
			interaction={{
				date: lead.interaction?.date,
				dateLabel: 'Date:',
				outcome: lead.interaction?.outcome?.name,
				outcomeColor: lead.interaction?.outcome?.hexColor,
				outcomeLabel: 'Outcome:',
			}}
		/>
	);
};
